import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AlertComponent from "../Components/AlertComponent";
import "./SignUp.css";
import { useRegister } from "../hooks/auth";
import {
  LinearProgress,
  Typography,
  Box,
  Button,
  TextField,
  Chip,
} from "@mui/material";
import GrainTexture from '../img/grain-texture-dark.png';

const SignUp = () => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();

  const { register, isLoading, toast, setToast } = useRegister();
  const [passwordStrength, setPasswordStrength] = useState(0);
  const [error, setError] = useState("");

  const calculatePasswordStrength = (password) => {
    let strength = 0;
    if (password.length >= 8) strength += 1;
    if (/[A-Z]/.test(password)) strength += 1;
    if (/[0-9]/.test(password)) strength += 1;
    if (/[^A-Za-z0-9]/.test(password)) strength += 1;
    setPasswordStrength(strength * 25);
  };

  const handleChangePassword = (e) => {
    setPassword(e.target.value);
    calculatePasswordStrength(e.target.value);
  };

  const handleChangeConfirmPassword = (e) => {
    setConfirmPassword(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirmPassword) {
      setError("Passwords don't match!");
      return;
    }

    try {
      await register({
        firstName,
        lastName,
        email,
        password,
        
        redirectTo: "/checkout",
      });

      setFirstName("");
      setLastName("");
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setError("");
    } catch (error) {
      setError("Invalid credentials. Please try again.");
    }
  };

  const [quote, setQuote] = useState("");

  useEffect(() => {
    fetch("https://api.quotable.io/random?tags=business")
      .then((response) => response.json())
      .then((data) => setQuote(data.content))
      .catch((error) => console.log(error));
  }, []);

  return (
    <section
      className="min-h-screen grid signup-wrapper"
      style={{
        display: "flex",
        flexDirection: "row",
      }}
    >
      <div className="p-6 signup-container" style={{ width: "70%" }}>
        <form onSubmit={handleSubmit}>
          <img
            src="https://uploads-ssl.webflow.com/63ff96d0ec9f196370caf50c/63ffc0597847ba335fb02b87_8CD41791-916C-4A1F-9551-C4A6FC79F96D.svg"
            alt="Luna-chatbot-ai-logo"
            style={{
              width: "80px",
              margin: "auto auto",
              background: "black",
              borderRadius: "100%",
            }}
          />

          <h2 className="text-center text-black text-3xl font-semibold mt-6">
            Sign Up
          </h2>
          <p className="mt-2 text-center text-xs text-gray-800">
            Create your account, explore our services and learn something new!
          </p>
          <Box sx={{ mt: 6, mb: 2 }}>
            <TextField
              value={firstName}
              onChange={(e) => setFirstName(e.target.value)}
              label="First Name"
              variant="outlined"
              placeholder="Richard"
              fullWidth
              required
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              value={lastName}
              onChange={(e) => setLastName(e.target.value)}
              label="Last Name"
              variant="outlined"
              placeholder="Hendricks"
              fullWidth
              required
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              label="Email"
              variant="outlined"
              placeholder="richard@piedpiper.com"
              fullWidth
              required
            />
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              value={password}
              onChange={handleChangePassword}
              label="Password"
              variant="outlined"
              type="password"
              fullWidth
              required
            />
            {password && (
              <React.Fragment>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <div style={{ width: "100%" }}>
                    <LinearProgress
                      variant="determinate"
                      value={passwordStrength}
                      sx={{
                        mt: 1,
                        mb: 1,
                        "& .MuiLinearProgress-bar": {
                          backgroundColor:
                            passwordStrength < 25 ? "#ff2045" : // Red for very weak
                            passwordStrength < 50 ? "#ffbe42" : // Yellow for weak
                            passwordStrength < 75 ? "#00C49F" : // Green for good
                            "#52c41a", // Strong security: Dark green
                        },
                      }}
                    />
                    <Typography
                      variant="caption"
                      color="text.secondary"
                      component="p"
                    >
                      Password strength:{" "}
                      {passwordStrength < 25
                        ? "Very weak"
                        : passwordStrength < 50
                        ? "Weak"
                        : passwordStrength < 75
                        ? "Good"
                        : "Strong"}
                    </Typography>
                  </div>
                </Box>
              </React.Fragment>
            )}
          </Box>
          <Box sx={{ mb: 2 }}>
            <TextField
              value={confirmPassword}
              onChange={handleChangeConfirmPassword}
              label="Confirm Password"
              variant="outlined"
              type="password"
              fullWidth
              required
            />
          </Box>

          {error && (
            <Box sx={{ mb: 2 }}>
              <Chip label={error} color="error" variant="outlined" />
            </Box>
          )}

          <Button
            disabled={isLoading}
            type="submit"
            variant="contained"
            fullWidth
            style={{
              background: "linear-gradient(45deg, #ff2045, #3d2fff)",
              color: "white",
            }}
          >
            Sign up
          </Button>
          <p className="text-sm mt-3 text-center">
            Already have an account?{" "}
            <span
              onClick={() => navigate("/login")}
              className="cursor-pointer text-[#812be2]"
            >
              Sign in
            </span>
          </p>
        </form>
      </div>
      <div
        className="image-section"
        style={{
          width: "50%",
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          className="rounded-lg"
          src={
            "https://app.svgator.com/assets/svgator.webapp/log-in-girl.svg"
          }
          alt="placeholder"
          style={{ maxWidth: "90%", margin: "auto auto", borderRadius: "100%" }}
        />
        {quote && (
          <p
            className="citation"
            style={{
              margin: "50px",
              color: "white",
              transform: "translateY(-10px)",
              fontStyle: "italic",
              fontSize: "12px",
              textAlign: "center",
            }}
          >
            {quote}
          </p>
        )}
      </div>
      <AlertComponent alert={toast} setOpenAlert={setToast} />
    </section>
  );
};

export default SignUp;
